var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.flixel.embedable || _vm.isOwner,
              expression: "flixel.embedable || isOwner"
            }
          ],
          staticClass: "social_list__item btn btn--black",
          class: { faded: _vm.isOwner && !_vm.flixel.embedable },
          on: {
            click: function($event) {
              _vm.embedOpen()
            }
          }
        },
        [_vm._v("Embed")]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.flixel.shareable || _vm.isOwner,
              expression: "flixel.shareable || isOwner"
            }
          ],
          staticClass: "social_list__item btn btn--black",
          class: { faded: _vm.isOwner && !_vm.flixel.shareable },
          attrs: { id: "filterBtn" },
          on: {
            click: function($event) {
              _vm.toggleSocial()
            }
          }
        },
        [
          _vm._v("Share"),
          _c("ul", [
            _c(
              "li",
              {
                on: {
                  click: function($event) {
                    _vm.socialClick("facebook")
                  }
                }
              },
              [
                _c(
                  "a",
                  {
                    attrs: {
                      href:
                        "http://www.facebook.com/sharer/sharer.php?u=" +
                        _vm.flixel.link
                    }
                  },
                  [_vm._v("Facebook")]
                )
              ]
            ),
            _c(
              "li",
              {
                on: {
                  click: function($event) {
                    _vm.socialClick("twitter")
                  }
                }
              },
              [
                _c(
                  "a",
                  {
                    attrs: {
                      href: "https://twitter.com/share?url=" + _vm.flixel.link
                    }
                  },
                  [_vm._v("Twitter")]
                )
              ]
            ),
            _c(
              "li",
              {
                on: {
                  click: function($event) {
                    _vm.socialClick("email")
                  }
                }
              },
              [
                _c(
                  "a",
                  {
                    attrs: {
                      href: "mailto:?subject=My Flixel&body=" + _vm.flixel.link
                    }
                  },
                  [_vm._v("Email")]
                )
              ]
            )
          ])
        ]
      ),
      _c(
        "p",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isOwner,
              expression: "isOwner"
            }
          ],
          staticClass: "owner-warning"
        },
        [
          _c("i", { staticClass: "fa fa-info-circle" }),
          _c("span", [
            _vm._v(
              "If embed or shared is greyed out, that means it will be hidden to other users."
            )
          ])
        ]
      ),
      _c("embed-popup", { attrs: { embed: _vm.embed, flixel: _vm.flixel } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1567c12f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1567c12f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SocialSharing.vue
// module id = null
// module chunks = 